import { SituacaoCompra } from "../shared/enums/situacao-compra.enum";
import { Boleto, Pix, Group } from "./purchase";

export class PurchaseItensRegister {
    public ehEditavel: boolean;
    constructor(
        public purchaseItemId: number,
        public purchaseId: number,
        public productId: number,
        public order: OrderRegister
    ){ }
}
export class OrderRegister {
    orderDescription: string;
    productGuid: string;
    productDescription: string;
    productColor: string;
    productIcon: string;
    orderState: number;
    orderItens: OrderItensRegister[];
    productCategory: number;
    orderStateDescription: string;
    orderValueToDeliver: number;
    constructor(
        public orderId: number,
        public assignorContractId: number,
        public purchaseItemId: number,
        public orderValue: number,
        public releaseDate: Date,
        public dueDate: Date,
        public managerId: number,
        public totalFee: number,
        public totalFeePercent: number,
        public isPercent: boolean)
    {}
}
export class OrderItensRegister {

    collaboratorId: number;
    hasApp: boolean;
    hasCard: boolean;
    hasAppDescription: string;
    registry: string;
    name: string;
    document: number;
    regularityId: number;
    regularityDescription: string;
    referenceValue: number;
    orderItemState: number;
    orderItemStateDescription: string;
    constructor(
        public orderItemId: number,
        public providedValue: number,
        public cardId: number,
        public comments: string){}
}

export class PurchaseRegister {
    public toCancel: boolean;
    isFlexPurchase: boolean;
    needChangeDate: boolean;
    managerGuid: string;
    depositId: number;
    identifier: string;
    assignorId: number;
    purchaseValueToDeliver: number;
    payment: Payment;
    pix: Pix;
    boleto: Boleto;

    constructor(
        public purchaseId: number,
        public purchaseItens: PurchaseItensRegister[],
        public group: Group,
        public purchaseValue: number,
        public purchaseValuePay: number,
        public purchaseDescription: string,
        public purchaseState: number,
        public purchaseStateDescription:string,
        public purchaseDate: Date,
        public paymentMethodId: number,
        public purchaseUseBalance: boolean,
        public purchaseFee: number,
        public situacaoId?: SituacaoCompra,
        ){

    }
}
export class Payment {
    bankGuid: string;
}
